import { useMutation, useLazyQuery } from "@apollo/client/react"; import React, { useEffect, useState, cloneElement } from 'react';
import { Stepper } from '../../../components/stepper/Stepper';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { STEPS, getStepByStatus } from './steps';

import toast, { Toaster } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { CREATE_PLAN_CUIDADO } from '../../../data/graphQL/mutations/PlanCuidado/createPlanCuidado';
import { CREATE_PLAN_CUIDADO_COMPLETE } from '../../../data/graphQL/mutations/PlanCuidado/createPlanCuidadoComplete';
import { UPDATE_PLAN_CUIDADO_COMPLETE } from '../../../data/graphQL/mutations/PlanCuidado/updatePlanCuidadoComplete';
import { EXIST_CODIGO_SAP } from '../../../data/graphQL/queries/PlanCuidado/ExistCodigoSap';

import './planCuidadoCreation.scss';
import { useLocation } from 'react-router-dom';

export const PlanCuidadoCreationContent = ({ setChildrenAction, setHeaderContent, setFooterContent }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const stateData = location.state;
  const editFullFormData = stateData?.Plan;
  const isDuplicate = stateData?.IsDuplicate;
  const allowedWriteParam = stateData?.AllowedWrite;
  var isNew = Boolean(!editFullFormData || editFullFormData && isDuplicate);
  const [steps, setSteps] = useState(STEPS);
  const [loadingGrabar, setLoadingGrabar] = useState(false);
  const [disabledGuardar, setDisabledGuardar] = useState(false);
  const [allowedWrite, setAllowedWrite] = useState(allowedWriteParam);
  const ESTADO_PLAN_INCOMPLETO = 2;

  const initialFormModel = {
    idPlanCuidado: 0,
    datosGenerales: {
      idPlanCuidado: '',
      idTipoModulo: 0,
      profesionales: editFullFormData?.datosGenerales?.profesionales || false,
      envios: editFullFormData?.datosGenerales?.envios || false,
      tm: editFullFormData?.datosGenerales?.tm || false,
      idUbicacionPlan: 0,
      idComplejidad: 0,
      idFranjaEtaria: 0,
      idReporteVenta: 0,
      idTipoServicio: 0,
      esquema: editFullFormData?.datosGenerales?.esquema || false,
      idTipoPlan: 0,
      topeCalAdulto: '',
      topeCalPediatrico: '',
      codigoSap: '',
      nombre: '',
      activo: editFullFormData?.datosGenerales?.activo || false,
      complejidad: editFullFormData?.datosGenerales?.complejidad || false,
      observacion: '',
      cotizado: editFullFormData?.datosGenerales?.cotizado || false,
      volumenInicial: '',
      volumenFinal: '',
      idModoInfusion: 0,
      idPlanCuidadoEstado: editFullFormData?.datosGenerales?.idPlanCuidadoEstado ? editFullFormData?.datosGenerales?.idPlanCuidadoEstado : ESTADO_PLAN_INCOMPLETO
    },
    delegaciones: [],
    clientes: [],
    documentoLegales: {
      bloqueaEnvio: editFullFormData?.documentoLegales?.bloqueaEnvio || false,
      firmaBloqueaInicio: editFullFormData?.documentoLegales?.firmaBloqueaInicio || false
    },
    documentoFacturaciones: [],
    insumos: [],
    dietas: [],
    fases: [],
    profesionales: []
  };

  const [fullFormData, setFullFormData] = useState(initialFormModel);
  const [existCodigoSap] = useLazyQuery(EXIST_CODIGO_SAP, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (isNew) {
      if (isDuplicate) {
        setFullFormData(editFullFormData);
        setFullFormData((previousData) => ({
          ...previousData,
          datosGenerales: {
            ...previousData.datosGenerales,
            idPlanCuidado: '',
            codigoSap: ''
          }
        }));
      }
      setDisabledGuardar(false);
    }
    else {
      setFullFormData(editFullFormData);
      setDisabledGuardar(!allowedWrite);
    }

  }, []);

  useEffect(() => {
    if (fullFormData.datosGenerales.idUbicacionPlan != 1 && !fullFormData.datosGenerales.envios && !fullFormData.datosGenerales.profesionales) {
      const newSteps = steps?.map((step) => {
        if (step?.order === 5 || step?.order === 6 || step?.order === 8) {
          return { ...step, status: 'DISABLED' };
        } else
          return step;
      });
      setSteps(newSteps);
    } else
      if (fullFormData.datosGenerales.idUbicacionPlan != 1 && fullFormData.datosGenerales.envios && fullFormData.datosGenerales.profesionales) {
        const newSteps = steps?.map((step) => {
          if (step?.order === 6 || step?.order === 8) {
            return { ...step, status: 'INACTIVE' };
          }
          if (step?.order === 5) {
            return { ...step, status: 'DISABLED' };
          } else
            return step;
        });
        setSteps(newSteps);
      } else
        if (fullFormData.datosGenerales.idUbicacionPlan != 1 && fullFormData.datosGenerales.envios && !fullFormData.datosGenerales.profesionales) {
          const newSteps = steps?.map((step) => {
            if (step?.order === 6) {
              return { ...step, status: 'INACTIVE' };
            }
            if (step?.order === 5 || step?.order === 8) {
              return { ...step, status: 'DISABLED' };
            } else
              return step;
          });
          setSteps(newSteps);
        } else
          if (fullFormData.datosGenerales.idUbicacionPlan != 1 && !fullFormData.datosGenerales.envios && fullFormData.datosGenerales.profesionales) {
            const newSteps = steps?.map((step) => {
              if (step?.order === 8) {
                return { ...step, status: 'INACTIVE' };
              }
              if (step?.order === 5 || step?.order === 6) {
                return { ...step, status: 'DISABLED' };
              } else
                return step;
            });
            setSteps(newSteps);
          } else
            if (fullFormData.datosGenerales.idUbicacionPlan == 1 && !fullFormData.datosGenerales.envios && !fullFormData.datosGenerales.profesionales) {
              const newSteps = steps?.map((step) => {
                if (step?.order === 5) {
                  return { ...step, status: 'INACTIVE' };
                }
                if (step?.order === 6 || step?.order === 8) {
                  return { ...step, status: 'DISABLED' };
                } else
                  return step;
              });
              setSteps(newSteps);
            } else
              if (fullFormData.datosGenerales.idUbicacionPlan == 1 && fullFormData.datosGenerales.envios && !fullFormData.datosGenerales.profesionales) {
                const newSteps = steps?.map((step) => {
                  if (step?.order === 5 || step?.order === 6) {
                    return { ...step, status: 'INACTIVE' };
                  }
                  if (step?.order === 8) {
                    return { ...step, status: 'DISABLED' };
                  } else
                    return step;
                });
                setSteps(newSteps);
              } else
                if (fullFormData.datosGenerales.idUbicacionPlan == 1 && !fullFormData.datosGenerales.envios && fullFormData.datosGenerales.profesionales) {
                  const newSteps = steps?.map((step) => {
                    if (step?.order === 5 || step?.order === 8) {
                      return { ...step, status: 'INACTIVE' };
                    }
                    if (step?.order === 6) {
                      return { ...step, status: 'DISABLED' };
                    } else
                      return step;
                  });
                  setSteps(newSteps);
                } else {
                  const newSteps = steps?.map((step) => {
                    if (step?.order === 5 || step?.order === 6 || step?.order === 8) {
                      return { ...step, status: 'INACTIVE' };
                    } else
                      return step;
                  });
                  setSteps(newSteps);
                }
  }, [fullFormData.datosGenerales.profesionales, fullFormData.datosGenerales.envios, fullFormData.datosGenerales.idUbicacionPlan]);

  const [createPlanCuidado, { error: createPlanCuidadoError }] = useMutation(CREATE_PLAN_CUIDADO, {
    onCompleted: (data) => adaptObjectProps(data.createPlanCuidado.idPlanCuidado, fullFormData),
    onError: () => {
      setDisabledGuardar(false);
      setLoadingGrabar(false);
      toast.error("Error al grabar el plan de cuidado");
    }
  });

  const [createPlanCuidadoComplete, { error: createPlanCuidadoCompleteError }] = useMutation(CREATE_PLAN_CUIDADO_COMPLETE, {
    onCompleted: () => {
      setDisabledGuardar(false);
      if (isNew)
        toast.success("Plan de cuidado grabado correctamente!");
      setTimeout(() => navigate('/buscarPlan'), 2000);
    },
    onError: () => {
      setDisabledGuardar(false);
      setLoadingGrabar(false);
      toast.error("Error al grabar el plan de cuidado");
    }
  });
  const [updatePlanCuidadoComplete, { error: updatePlanCuidadoCompleteError }] = useMutation(UPDATE_PLAN_CUIDADO_COMPLETE, {
    onCompleted: () => {
      const {
        datosGenerales,
        delegaciones,
        clientes,
        documentoLegales,
        documentoFacturaciones,
        insumos,
        dietas,
        fases,
        profesionales
      } = fullFormData;

      // Filtra elementos que contengan o no una prop determinada
      const filterByPropName = (dataArray, prop, exists = false) => {
        return dataArray?.filter((item) => exists ? item[prop] : !item[prop]);
      };

      const creationAdaptedObject = {
        ...initialFormModel,
        delegaciones: [...filterByPropName(delegaciones, 'idPlanCuidadoDelegacion')],
        clientes: [...filterByPropName(clientes, 'idPlanCuidadoAtributo')],
        documentoLegales: documentoLegales,
        documentoFacturaciones: [...filterByPropName(documentoFacturaciones, 'idPlanCuidadoDocumentoFac')],
        insumos: [...filterByPropName(insumos, 'idPlanCuidadoInsumo')],
        dietas: [...filterByPropName(dietas, 'idPlanCuidadoDieta')],
        profesionales: [...filterByPropName(profesionales, 'idPlanCuidadoFaseProfesional')],
        fases: [...filterByPropName(fases, 'idPlanCuidadoFase')]
      };

      if (Object.entries(creationAdaptedObject)?.some(([_, value]) => value?.length > 0) ||
        documentoLegales.idPlanCuidadoDocumentoLegal === 0) {
        adaptObjectProps(datosGenerales?.idPlanCuidado, creationAdaptedObject, true);
      }

      setDisabledGuardar(false);
      toast.success("Plan de cuidado modificado correctamente!");
      setTimeout(() => navigate('/buscarPlan'), 1000);
    },
    onError: () => {
      setDisabledGuardar(false);
      setLoadingGrabar(false);
      toast.error("Error al grabar el plan de cuidado");
    }
  });

  const isValid = () => {
    const valid = validateFormByOrder(4); // facturacion
    if (valid.length > 0) {
      toast.error(valid.toString());
      return false;
    }

    if (steps.find((s) => s.order === 5)?.status !== 'DISABLED') {
      const requiredFields = validateFormByOrder(5); //Legales
      if (requiredFields.length > 0) {
        toast.error(requiredFields.toString());
        return false;
      }
    }
    if (steps.find((s) => s.order === 8)?.status !== 'DISABLED') {
      const requiredFields = validateFormByOrder(8); //Pofesionales
      if (requiredFields.length > 0) {
        toast.error(requiredFields.toString());
        return false;
      }
    }

    return true;
  };

  const handleClickCreate = async (e) => {
    if (isValid()) {
      const { data: validateCodSap } = await existCodigoSap({
        variables: {
          idPlanCuidado: fullFormData.datosGenerales.idPlanCuidado != '' ? fullFormData.datosGenerales.idPlanCuidado : undefined,
          codigoSap: fullFormData.datosGenerales.codigoSap,
          clientes: fullFormData.clientes.length > 0 ? fullFormData.clientes.map((x) => x.codigoSapCliente) : undefined
        }
      });
      // Valido si existe codigo sap
      if (validateCodSap.existCodigoSap) {
        toast.error("Código SAP existente.");
      } else {
        setDisabledGuardar(true);
        setLoadingGrabar(true);

        createPlanCuidado({
          variables: {
            codigoSap: fullFormData?.datosGenerales?.codigoSap,
            nombre: fullFormData?.datosGenerales?.nombre,
            activo: fullFormData?.datosGenerales?.activo,
            idTipoServicio: fullFormData?.datosGenerales?.idTipoServicio,
            esquema: fullFormData?.datosGenerales?.esquema,
            idUbicacion: fullFormData?.datosGenerales?.idUbicacionPlan,
            idFranjaEtaria: fullFormData?.datosGenerales?.idFranjaEtaria,
            idComplejidad: fullFormData?.datosGenerales?.idComplejidad,
            idReporteVenta: fullFormData?.datosGenerales?.idReporteVenta,
            idTipoPlan: fullFormData?.datosGenerales?.idTipoPlan,
            topePediatrico: fullFormData?.datosGenerales?.topeCalPediatrico !== 0 ? parseFloat(fullFormData?.datosGenerales?.topeCalPediatrico) : null,
            topeAdulto: fullFormData?.datosGenerales?.topeCalAdulto !== 0 ? parseFloat(fullFormData?.datosGenerales?.topeCalAdulto) : null,
            profesionales: fullFormData?.datosGenerales?.profesionales,
            tm: fullFormData?.datosGenerales?.tm,
            envios: fullFormData?.datosGenerales?.envios,
            complejidad: fullFormData?.datosGenerales?.complejidad,
            observacion: fullFormData?.datosGenerales?.observacion !== '' ? fullFormData?.datosGenerales?.observacion : null,
            state: fullFormData?.datosGenerales?.codigoSap === '' ? 'INCOMPLETO' : 'VALIDACION',
            idTipoModulo: fullFormData?.datosGenerales?.idTipoModulo,
            cotizado: fullFormData?.datosGenerales?.cotizado,
            volumenInicial: fullFormData?.datosGenerales?.volumenInicial !== 0 ? parseInt(fullFormData?.datosGenerales?.volumenInicial) : null,
            volumenFinal: fullFormData?.datosGenerales?.volumenFinal !== 0 ? parseInt(fullFormData?.datosGenerales?.volumenFinal) : null,
            idModoInfusion: fullFormData?.datosGenerales?.idModoInfusion
          }
        });
      }
    }
  };

  const adaptObjectProps = (idPlanCuidado, formData, isEdition = false) => {
    // Separamos props que sirven, de las que no (datosgrales)
    const { datosGenerales, ...props } = formData;
    // Filtramos props que no necesitan idPlanCuidado osea idPlanCuidado
    const propsAModificar = Object.entries(props)?.map(([key, _]) => key).filter((nombre) => nombre !== 'idPlanCuidado' && nombre !== 'documentoLegales' && nombre !== '__typename');

    // Convertimos a diccionario y filtramos cada prop relevante, mapeaos a objeto cada clave y valor, y agregando idPlanCuidado a cada objeto del array
    const objetoFinal = Object.fromEntries(Object.entries(props)?.
      filter(([key, _]) => propsAModificar.includes(key))?.
      map(([key, value]) =>
        [key,
          value?.map(({ __typename, ...obj }) => ({ ...obj, idPlanCuidado: idPlanCuidado }))]

      ));
    // elimino prop insumo de planCuidadoInsumo
    objetoFinal.insumos = objetoFinal?.insumos?.map((obj) => {
      // Crear una copia del insumo sin la propiedad a eliminar
      const { insumo, id, idPlanCuidadoInsumo, ...planCuidadoInsumo } = obj;
      // planCuidadoInsumo.excepcion = planCuidadoInsumo.excepcion.map((alergia) => { return { idAlergia: alergia?.idAlergia ?? alergia }; });
      return planCuidadoInsumo;
    });

    objetoFinal.dietas = objetoFinal?.dietas?.map((obj) => {
      // Crear una copia de la dieta sin la propiedad a eliminar
      const { id, idPlanCuidadoDieta, ...dieta } = obj;
      return dieta;
    });

    objetoFinal.clientes = objetoFinal?.clientes?.map((obj) => {
      // Crear una copia del cliente sin la propiedad a eliminar
      const { id, idPlanCuidadoAtributo, ...cliente } = obj;
      return cliente;
    });

    objetoFinal.delegaciones = objetoFinal?.delegaciones?.map((obj) => {
      // Crear una copia de la delegacion sin la propiedad a eliminar
      const { idPlanCuidadoDelegacion, ...delegacion } = obj;
      return delegacion;
    });

    objetoFinal.documentoFacturaciones = objetoFinal?.documentoFacturaciones?.map((obj) => {
      // Crear una copia de la documentacion de facturacion sin la propiedad a eliminar
      const { idPlanCuidadoDocumentoFac, ...docFacturacion } = obj;
      return docFacturacion;
    });

    objetoFinal.profesionales = objetoFinal?.profesionales?.map((obj) => {
      // Crear una copia del profesional sin la propiedad a eliminar
      const { idPlanCuidadoFaseProfesional, idPlanCuidado, ...profesional } = obj;
      return profesional;
    });

    objetoFinal.fases = objetoFinal?.fases?.map((obj) => {
      // Crear una copia del fase sin la propiedad a eliminar
      const { idPlanCuidadoFase, ...fase } = obj;
      return fase;
    });

    delete formData.documentoLegales.__typename;
    delete formData.documentoLegales.idPlanCuidado;
    delete formData.documentoLegales.idPlanCuidadoDocumentoLegal;



    const profesionalesAdapted = (profesionales) => {
      return profesionales?.map((obj) => {
        // Crear una copia del profesional sin la propiedad a eliminar
        const { _rowId, ...profesional } = obj;
        return profesional;
      });
    };

    createPlanCuidadoComplete({
      variables: {
        planCuidadoId: idPlanCuidado,
        delegaciones: objetoFinal?.delegaciones,
        clientes: objetoFinal?.clientes,
        documentoLegales: steps.find((s) => s.order === 5)?.status === 'DISABLED' ? null : formData?.documentoLegales,
        documentoFacturaciones: objetoFinal?.documentoFacturaciones,
        insumos: objetoFinal?.insumos,
        dietas: objetoFinal?.dietas,
        fases: objetoFinal?.fases,
        profesionales: profesionalesAdapted(objetoFinal?.profesionales),
        isEdition: isEdition
      }
    });

    return objetoFinal;
  };

  const handleClickEdit = async (e) => {
    // Ejecuto createcomplete si los length > 0 de los array de initialFormModel
    // Ejecuto edit siempre y filtramos del objeto aquellas props sin su respectivo id
    // TODO: Validaciones en EDIT, comparar objetos modificados con originales
    const {
      datosGenerales,
      delegaciones,
      clientes,
      documentoLegales,
      documentoFacturaciones,
      insumos,
      dietas,
      fases,
      profesionales
    } = fullFormData;

    if (isValid()) {

      // Filtra elementos que contengan o no una prop determinada
      const filterByPropName = (dataArray, prop, exists = false) => {
        return dataArray?.filter((item) => exists ? item[prop] : !item[prop]);
      };

      delete documentoLegales.__typename;

      // Valido si existe codigo sap
      const { data } = await existCodigoSap({
        variables: {
          idPlanCuidado: fullFormData.datosGenerales.idPlanCuidado != '' ? fullFormData.datosGenerales.idPlanCuidado : undefined,
          codigoSap: fullFormData.datosGenerales.codigoSap,
          clientes: fullFormData.clientes.length > 0 ? fullFormData.clientes.map((x) => x.codigoSapCliente) : undefined
        }
      });
      // Valido si existe codigo sap
      if (data.existCodigoSap) {
        toast.error("Código SAP existente.");
      }
      // // TODO: Añadir validacion, deberia entrar al if solo si existen cambios entre el objeto original y el objeto a enviar al tocar el boton
      else if (!fullFormData.datosGenerales?.profesionales || fullFormData.datosGenerales?.profesionales && profesionales?.length > 0) {
        setLoadingGrabar(true);

        // Removemos props innecesarias de datosGenerales
        const { 
          codigoSap, 
          idTipoPrograma, 
          idSubTipoPrograma, 
          tm, 
          idUbicacionPlan, 
          topeCalPediatrico, 
          topeCalAdulto, 
          volumenInicial, 
          volumenFinal, 
          __typename, 
          ...datosGralesProps
         } = fullFormData?.datosGenerales || {};

        const editAdaptedObject =
          Object.fromEntries(
            Object.entries(
              {
                ...fullFormData,
                datosGenerales: {
                  ...datosGralesProps,
                  codigoSap: codigoSap,
                  tM: tm,
                  idUbicacion: idUbicacionPlan,
                  topePediatrico: parseFloat(topeCalPediatrico),
                  topeAdulto: parseFloat(topeCalAdulto),
                  volumenInicial: parseInt(volumenInicial),
                  volumenFinal: parseInt(volumenFinal),
                  state: codigoSap === '' ? 'INCOMPLETO' : 'VALIDACION'
                },
                delegaciones: [...filterByPropName(delegaciones, 'idPlanCuidadoDelegacion', true)],
                clientes: [...filterByPropName(clientes, 'idPlanCuidadoAtributo', true)],
                documentoFacturaciones: [...filterByPropName(documentoFacturaciones, 'idPlanCuidadoDocumentoFac', true)],
                insumos: [...filterByPropName(insumos, 'idPlanCuidadoInsumo', true)],
                dietas: [...filterByPropName(dietas, 'eleccion', true)],
                //profesionales: [...filterByPropName(profesionales, 'idFrecuenciaProfesional', true)],
                fases: [...filterByPropName(fases, 'idPlanCuidadoDuracionFase', true)]
              }
              // Eliminamos __typename, propiedad residual de la query
            )?.map(([key, value]) => {
              if (value?.length && typeof value !== 'string') {
                return [key, value?.map((v) => {
                  const { __typename, ...props } = v;
                  return props;
                })];
              } else {
                return [key, value];
              }
            }));

        editAdaptedObject.insumos = editAdaptedObject?.insumos?.map((obj) => {
          // Crear una copia del insumo sin la propiedad a eliminar
          const { insumo, id, ...planCuidadoInsumo } = obj;
          // planCuidadoInsumo.excepcion = planCuidadoInsumo.excepcion.map((alergia) => { return { idAlergia: alergia.idAlergia != null ? alergia.idAlergia : alergia }; });
          return planCuidadoInsumo;
        });

        editAdaptedObject.dietas = editAdaptedObject?.dietas?.map((obj) => {
          // Crear una copia de la dieta sin la propiedad a eliminar
          const { id, ...dieta } = obj;
          return dieta;
        });

        editAdaptedObject.clientes = editAdaptedObject?.clientes?.map((obj) => {
          // Crear una copia del cliente sin la propiedad a eliminar
          const { id, ...cliente } = obj;
          return cliente;
        });

        setDisabledGuardar(true);

        const profesionalesAdapted = (profesionales) => {
          return profesionales?.map((obj) => {
            // Crear una copia del profesional sin la propiedad a eliminar
            const { _rowId, ...profesional } = obj;
            return profesional;
          });
        };

        updatePlanCuidadoComplete({
          variables: {
            datosGenerales: editAdaptedObject?.datosGenerales,
            delegaciones: editAdaptedObject?.delegaciones,
            clientes: editAdaptedObject?.clientes,
            documentoLegales: editAdaptedObject?.documentoLegales,
            documentoFacturaciones: editAdaptedObject?.documentoFacturaciones,
            insumos: editAdaptedObject?.insumos,
            dietas: editAdaptedObject?.dietas,
            fases: editAdaptedObject?.fases,
            profesionales: profesionalesAdapted(editAdaptedObject?.profesionales),
            newInsumos: insumos?.length > editAdaptedObject?.insumos?.length
          }
        });

      } else {
        toast.error('Debe ingresar al menos un profesional');
      }
    }
  };

  useEffect(() => {
    setChildrenAction(() =>
      <div className='header-plan-cuidado'>
        <CustomButton
          disabled={steps.find((step) => step.status === 'ACTIVE')?.order === 1}
          onClick={() => handleChangeStep(false)}
          previousArrow={!(steps.find((step) => step.status === 'ACTIVE')?.order === 1)}
          noOutline={true}
          size="small"
          variant="outlined"
          className='back-button'>

          Anterior
        </CustomButton>

        <div className='button-divider'></div>
        {( //(steps.find((step) => step.status === 'ACTIVE')?.order === 4 && fullFormData.datosGenerales.idUbicacionPlan !== 1 && !fullFormData.datosGenerales.envios && !fullFormData.datosGenerales.profesionales)
          //(steps.find((step) => step.status === 'ACTIVE')?.order === 7 && fullFormData.datosGenerales.idUbicacionPlan === 1 && !fullFormData.datosGenerales.envios && !fullFormData.datosGenerales.profesionales)
          //|| 
          (steps.find((step) => step.status === 'ACTIVE')?.order === 7 && !fullFormData.datosGenerales.profesionales)
          || steps.find((step) => step.status === 'ACTIVE')?.order === steps.length) && !stateData?.IsView
          ?
          <CustomButton
            isLoading={loadingGrabar}
            onClick={isNew ? handleClickCreate : handleClickEdit}
            size="small"
            disabled={disabledGuardar}>

            {isNew ? 'Crear' : 'Editar'}
          </CustomButton> :

          <CustomButton
            onClick={() => handleChangeStep(true)}
            size="small"
            nextArrow
            variant="outlined"
            noOutline={true}
            disabled={steps.find((step) => step.status === 'ACTIVE')?.order === steps.length && stateData?.IsView}>

            Siguiente
          </CustomButton>}
      </div>
    );
    setHeaderContent(() =>
      <div
        className='header-plan-cuidado-step-datosGenerales'>
        <Stepper steps={steps} />
      </div>
    );
    setFooterContent(() =>
      <div className='footer-plan-cuidado'>
      </div>
    );
  }, [setChildrenAction, setHeaderContent, steps, fullFormData, loadingGrabar, disabledGuardar]);

  const handleChangeStep = (isNext) => {
    const isNextIndex = isNext ? 1 : -1;
    const currentStep = steps?.find((step) => step?.status.toUpperCase() === 'ACTIVE');
    const nextStep = steps?.find((step) => step?.order === currentStep?.order + isNextIndex);

    if (currentStep && nextStep) {
      const fields = validateFormByOrder(currentStep.order);
      if (currentStep.order === 1) {
        let topePediatrico = parseFloat(fullFormData.datosGenerales.topeCalPediatrico);
        let topeAdulto = parseFloat(fullFormData.datosGenerales.topeCalAdulto);

        if (topePediatrico < 0 || topePediatrico > 3000) {
          toast.error('El Tope de Calorias Pediatrico debe estar en 0 y 3000');
          return;
        }
        if (topeAdulto < 0 || topeAdulto > 3000) {
          toast.error('El Tope de Calorias Adulto debe estar en 0 y 3000');
          return;
        }
        if (fullFormData.datosGenerales.idTipoModulo === 2 ||
          fullFormData.datosGenerales.idTipoModulo === 10 ||
          fullFormData.datosGenerales.idTipoModulo === 14) {
          let volumenInicial = parseInt(fullFormData.datosGenerales.volumenInicial);
          let volumenFinal = parseInt(fullFormData.datosGenerales.volumenFinal);

          if (volumenInicial < 0 || volumenInicial > 4000) {
            toast.error('El Volumen Inicial debe estar en 0 y 4000');
            return;
          }
          if (volumenFinal < 100 || volumenFinal > 4500) {
            toast.error('El Volumen Final debe estar en 100 y 4500');
            return;
          }
          if (volumenInicial >= volumenFinal) {
            toast.error('El Volumen Inicial debe ser menor al Volumen Final');
            return;
          }
        }

      }
      if (fields.length > 0 && isNext) {
        if (currentStep.order === 2) {
          toast.error('Debe seleccionar al menos una delegación');
        } else
          if (currentStep.order === 4) {
            toast.error('Debe seleccionar al menos un documento');
          } else {
            toast.error('Los siguientes campos son requeridos : ' + fields.join(', '));
          }
      } else {
        const newSteps = steps?.map(step => {
          if (step?.order === currentStep?.order) {
            return { ...step, status: isNext ? 'COMPLETED' : 'INACTIVE' }
          } else if (step?.order === currentStep?.order + isNextIndex) {
            //si esta deshabilitado no lo activo
            if (step?.status !== 'DISABLED') {
              return { ...step, status: 'ACTIVE' }
            }
            return step;
            //atras  
          } else if (step?.order === 5 && currentStep?.order === 7 && steps.find(s => s.order === 6)?.status === 'DISABLED' && steps.find(s => s.order === 5)?.status !== 'DISABLED' && !isNext) {
            if (step?.status !== 'DISABLED') {
              return { ...step, status: 'ACTIVE' };
            }
            return step;
          } else if (step?.order === 4 && currentStep?.order === 7 && steps.find(s => s.order === 6)?.status === 'DISABLED' && steps.find(s => s.order === 5)?.status === 'DISABLED' && !isNext) {
            if (step?.status !== 'DISABLED') {
              return { ...step, status: 'ACTIVE' };
            }
            return step;
          } else if (step?.order === 4 && currentStep?.order === 6 && steps.find(s => s.order === 5)?.status === 'DISABLED' && steps.find(s => s.order === 5)?.status === 'DISABLED' && !isNext) {
            if (step?.status !== 'DISABLED') {
              return { ...step, status: 'ACTIVE' };
            }
            return step;
            // } else if (step?.order === 4 && currentStep?.order === 8 && steps.find(s => s.order === 5)?.status === 'DISABLED' && steps.find(s => s.order === 6)?.status === 'DISABLED' && !isNext) {
            //     if (step?.status !== 'DISABLED') {
            //         return { ...step, status: 'ACTIVE' };
            //     }
            //     return step;
            // } else if (step?.order === 7 && currentStep?.order === 8 && steps.find(s => s.order === 5)?.status === 'DISABLED' && steps.find(s => s.order === 6)?.status !== 'DISABLED' && !isNext) {
            //     if (step?.status !== 'DISABLED') {
            //         return { ...step, status: 'ACTIVE' };
            //     }
            //     return step;
          } else if (step?.order === 7 && currentStep?.order === 8 && !isNext) {
            if (step?.status !== 'DISABLED') {
              return { ...step, status: 'ACTIVE' };
            }
            return step;
            // siguientes
          } else if (step?.order === 7 && currentStep?.order === 4 && steps.find(s => s.order === 5)?.status === 'DISABLED' && steps.find(s => s.order === 6)?.status === 'DISABLED' && isNext) {
            if (step?.status !== 'DISABLED') {
              return { ...step, status: 'ACTIVE' };
            }
            return step;
          } else if (step?.order === 7 && currentStep?.order === 5 && steps.find(s => s.order === 6)?.status === 'DISABLED' && steps.find(s => s.order === 7)?.status !== 'DISABLED' && isNext) {
            if (step?.status !== 'DISABLED') {
              return { ...step, status: 'ACTIVE' };
            }
            return step;
          } else if (step?.order === 6 && currentStep?.order === 4 && steps.find(s => s.order === 5)?.status === 'DISABLED' && steps.find(s => s.order === 6)?.status !== 'DISABLED' && isNext) {
            if (step?.status !== 'DISABLED') {
              return { ...step, status: 'ACTIVE' };
            }
            return step;
          } else if (step?.order === 8 && currentStep?.order === 4 && steps.find(s => s.order === 5)?.status === 'DISABLED' && steps.find(s => s.order === 6)?.status === 'DISABLED' && isNext) {
            if (step?.status !== 'DISABLED') {
              return { ...step, status: 'ACTIVE' };
            }
            return step;
            // } else if (step?.order === 8 && currentStep?.order === 5 && steps.find(s => s.order === 5)?.status !== 'DISABLED' && steps.find(s => s.order === 6)?.status === 'DISABLED' && isNext) {
            //     if (step?.status !== 'DISABLED') {
            //         return { ...step, status: 'ACTIVE' };
            //     }
            //     return step;
          }
          else return step;
        });
        setSteps(newSteps);
      }
    }
  };

  const validateFormByOrder = (order) => {
    const requiredFields = [];
    switch (order) {
      case 1: //Datos Generales
        {
          if (fullFormData.datosGenerales.nombre === '') {
            requiredFields.push('Nombre');
          }

          if (fullFormData.datosGenerales.idTipoServicio === 0) {
            requiredFields.push('Tipo de servicio');
          }

          if (fullFormData.datosGenerales.idUbicacionPlan === 0) {
            requiredFields.push('Ubicación plan');
          }

          if (fullFormData.datosGenerales.idFranjaEtaria === 0) {
            requiredFields.push('Franja etaria');
          }

          if (fullFormData.datosGenerales.idComplejidad === 0) {
            requiredFields.push('Complejidad');
          }

          if (fullFormData.datosGenerales.idReporteVenta === 0) {
            requiredFields.push('Reporte ventas');
          }

          if (fullFormData.datosGenerales.idTipoPlan === 0) {
            requiredFields.push('Tipo de plan');
          }
          // si es AP, SIP o NPID
          if (fullFormData.datosGenerales.idTipoModulo === 2 ||
            fullFormData.datosGenerales.idTipoModulo === 10 ||
            fullFormData.datosGenerales.idTipoModulo === 14) {
            if (fullFormData.datosGenerales.volumenInicial === null || fullFormData.datosGenerales.volumenInicial?.length <= 0) {
              requiredFields.push('Volumen inicial');
            }
            if (fullFormData.datosGenerales.volumenFinal === null || fullFormData.datosGenerales.volumenFinal?.length <= 0) {
              requiredFields.push('Volumen final');
            }
            if (fullFormData.datosGenerales.idModoInfusion === null || fullFormData.datosGenerales?.idModoInfusion === 0) {
              requiredFields.push('Modo de infusión');
            }
          }
        }
        break;
      case 2: //Delegaciones
        {
          if (fullFormData.delegaciones.length === 0) {
            requiredFields.push('Delegaciones');
          }
        }
        break;
      case 4: //Facturacion
        {
          if (fullFormData.documentoFacturaciones.length === 0) {
            requiredFields.push('Debe seleccionar al menos un documento');
          }
        }
        break;
      case 5: //Legales
        // {
        //   if (fullFormData.datosGenerales.idUbicacionPlan == 1 && !fullFormData?.documentoLegales?.idDocumentoLegal) {
        //     requiredFields.push('El documento legal es requerido');
        //   }
        // }
        break;
      case 8: //Profesionales
        {
          //Al menos una fase obligatoria
          if (fullFormData.fases.length === 0) {
            requiredFields.push('Debe seleccionar al menos una fase');
          }
          //Al menos un profesional requerido
          if (fullFormData.profesionales.length === 0) {
            requiredFields.push('Debe seleccionar al menos un profesional');
          }

          //No debe exisitir el mimso tipo profesional y especialidad en la misma fase a menos que
          // cambie el modo de visita. Y que no se haya completado los dias de la fase.
          //Si es sin limite no puede haber el mismo profesional y especialidad en la fase.


          // Si hay una fase sin limite, no deberia haber opciones en FDuracion.
          //(hay que validar que FDuracion no pase la cantidad de dias para la misma fase).
        }
        break;
      default:
        break;
    }

    return requiredFields;
  };

  return (
    <>

      <div className='plan-cuidado-creation'>
        {steps?.map((step) => {
          return (
            cloneElement(getStepByStatus(step.order, steps)?.component || <></>, {
              stepsData: fullFormData,
              setStepsData: setFullFormData
            }));

        })}
      </div>
    </>);

};